<div
    *transloco="let tManageFields; read: 'manage_fields'"
    class="flex xsm:flex-row items-center justify-between mb-2"
>
    <div
        class="grow flex items-center gap-4 pr-4 pl-2.5 py-2 rounded shadow-md bg-neutral1 border-l-[0.375rem]"
        [style.border-color]="workspace.color.value"
    >
        <div class="w-[calc(50%+0.5rem)] flex body-1">
            <span class="cursor-default">{{ field.name }}</span>
            <app-tb-tooltip-component [tooltip]="tManageFields('required_tooltip')">
                @if (field.is_required) {
                    <app-tb-icon
                        icon="asterisk"
                        color="textLight"
                        class="icon-xs cursor-pointer ml-[0.125rem]"
                    ></app-tb-icon>
                }
            </app-tb-tooltip-component>
            <app-tb-tooltip-component [tooltip]="tManageFields('on_top_tooltip')">
                @if (field.is_on_top) {
                    <app-tb-icon
                        icon="upgrade"
                        color="textLight"
                        class="icon-xs cursor-pointer ml-[0.125rem]"
                    ></app-tb-icon>
                }
            </app-tb-tooltip-component>
        </div>
        @if (field.workspace_name?.name ?? tManageFields('unknown_workspace'); as workspaceName) {
            <!--TODO: move to tooltip-->
            <app-tb-tooltip-component
                [tooltip]="workspaceName"
                [showOnlyOnOverflow]="true"
                class="w-1/4 caption-1"
            >
                <div class="rounded bg-neutral2 py-0.5 px-2 inline-block cursor-default">
                    <span
                        class="caption-1 text-ellipsis overflow-hidden whitespace-nowrap text-textLight"
                        >{{ workspaceName }}</span
                    >
                </div>
            </app-tb-tooltip-component>
        }
        <div class="flex items-center w-1/4 cursor-default">
            @if (fieldType?.icon; as icon) {
                <app-tb-icon [icon]="icon" color="textLight" class="icon-sm mr-1"> </app-tb-icon>
            }
            @if (fieldType?.name ?? tManageFields('unknown_type'); as type) {
                <app-tb-tooltip-component
                    [tooltip]="type"
                    [showOnlyOnOverflow]="true"
                    class="caption-1"
                >
                    <span
                        #typeBlock
                        class="text-ellipsis overflow-hidden whitespace-nowrap capitalize text-textLight"
                    >
                        {{ type }}
                    </span>
                </app-tb-tooltip-component>
            }
        </div>
    </div>
    <app-tb-more-menu
        triggerColor="primaryLight"
        [template]="fieldOptions"
        xPosition="after"
    ></app-tb-more-menu>
    <ng-template
        class="mb-2"
        #fieldOptions
        let-containerLayout="containerLayout"
        let-close="closeFn"
    >
        <app-manage-field-field-options
            [field]="field"
            [selectedWorkspace]="workspace"
            [containerLayout]="containerLayout"
            [close]="close"
            (deleteField)="deleteField.emit(field)"
        ></app-manage-field-field-options>
    </ng-template>
</div>
